import { getRecommendBundle, SolarCalcPage } from '../solar-calculator';
import css from './index.module.scss';
import Modal from './modal';
import { FormatMoney } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import { getSolarRecommand } from '@/service/solar-calculator';

export default function Step5({ calObj, callBack }: any) {
    const { useLang, useState, useEffect, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('calculatorssolarpanels');
    const [showModal, setShowModal] = useState({ visible: false, num: 0 });
    const staticItems = getRecommendBundle(
        locale,
        calObj?.check1 === 'outdoor' ? ([0, 1, 2].includes(calObj?.check2) ? 'outdoor_1' : 'outdoor_2') : calObj?.check1,
        calObj?.check1 !== 'work' ? (calObj?.check4 === 1 || calObj?.totalPower > 1 ? 'type2' : 'type1') : calObj?.totalPower > 1 ? 'type2' : 'type1',
    );
    const [items, setItems] = useState([...staticItems]);

    const handleBack = () => {
        callBack({ ...calObj, currentPage: SolarCalcPage.Step4, currentStep: 4 }, true);
    };

    useEffect(() => {
        const tempArr = [...items];
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        tempArr[k].variantImg = res?.data?.variantImg;
                        tempArr[k].price = res?.data?.price;
                        tempArr[k].originalPrice = res?.data?.compareAtPrice;
                        if (!tempArr[k]?.img && res?.data?.img) {
                            tempArr[k].img = res?.data?.img;
                        }
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };
        const promises = staticItems?.map((item: any, k: number) => getAsynItem(item?.productId, item.variantId, k));
        Promise.all(promises)
            .then(() => {
                setItems(tempArr);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);
    return (
        <div className={`step5 ${css.step5}`}>
            <p className="step5-title">{t('step5_title')}</p>
            <ul className="step5-box">
                {items?.map((item: any, k: number) => (
                    <li className="step5-item" key={k}>
                        <div className="img-box">
                            <NextImage src={item?.variantImg} alt={item.text} aria-label={item.text} />
                        </div>
                        <div className="text-box">
                            {item.bestSeller ? (
                                <p className="tag yellow">{t('step5_tag_best_seller')}</p>
                            ) : (
                                <p className="tag red">{t('step5_tag_recommend')}</p>
                            )}

                            <p className="title">{item?.title}</p>
                            {!item?.hideConnection && (
                                <p className="connect" onClick={() => setShowModal({ visible: true, num: item?.num })}>
                                    {t('step5_connection')}
                                </p>
                            )}
                            <div className="info">
                                {item?.otherText && (
                                    <>
                                        {item?.otherText}
                                        <br />
                                    </>
                                )}
                                {t('step5_capacity')} {item?.capacity}
                                <br />
                                {t('step5_output')} {item?.output}
                                <br />
                                {item.input && (
                                    <>
                                        {t('step5_input')} {item?.input}
                                        <br />
                                    </>
                                )}
                                {item?.time && (
                                    <>
                                        {t('step5_time')} {item.time}
                                        <br />
                                    </>
                                )}
                                {t('step5_weight')} {item?.totalWeight} {t('step5_weight_unit')}
                            </div>
                            <div className="price">
                                <span className="discount">
                                    {t('step5_money_unit')}
                                    {FormatMoney(item.price)}
                                </span>
                                {item?.originalPrice && item?.originalPrice !== item.price && (
                                    <span className="original">
                                        {t('step5_money_unit')}
                                        {FormatMoney(item.originalPrice)}
                                    </span>
                                )}
                            </div>
                            <div className="payment">
                                {item.tips?.map?.((j: number, idx2: number) => (
                                    <span className="payment-text" key={idx2}>
                                        {t.rich(`step5_tip${j}`, {
                                            PayPal: () => (
                                                <img
                                                    style={{ marginLeft: 6 }}
                                                    height="14px"
                                                    src="https://websiteoss.ecoflow.com/upload/image/1749547350252/paypal.png"
                                                    loading="lazy"
                                                />
                                            ),
                                            Afterpay: () => (
                                                <img
                                                    style={{ marginLeft: 6 }}
                                                    height="12px"
                                                    src="https://websiteoss.ecoflow.com/upload/image/1749547350072/afterpay.png"
                                                    loading="lazy"
                                                />
                                            ),
                                            Zip: () => (
                                                <img
                                                    style={{ marginLeft: 6 }}
                                                    height="14px"
                                                    src="https://websiteoss.ecoflow.com/upload/image/1749547350536/zip.png"
                                                    loading="lazy"
                                                />
                                            ),
                                        })}
                                    </span>
                                ))}
                            </div>
                            <div className="btns">
                                <Link className="more" href={`${item.link}?variant=${item.variantId}`}>
                                    {t('step5_learn')}
                                </Link>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
            <div className="step5-btns">
                <button className="btn-back" onClick={handleBack}>
                    {t('common_back')}
                </button>
                <Link className="btn-next" href={t('common_learn_url')} target="_blank">
                    {t('common_learn')}
                </Link>
            </div>
            {showModal?.visible && <Modal number={showModal?.num} callback={() => setShowModal({ visible: false, num: 0 })} />}
        </div>
    );
}
